import { render, staticRenderFns } from "./productCarousel.vue?vue&type=template&id=6eaf6603"
import script from "./productCarousel.vue?vue&type=script&lang=js"
export * from "./productCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports